import React from 'react';
import _ from 'lodash';
import moment from 'moment';
import SearchBar from '../../../../searchbar/SearchBar';
import FieldSet from '../../../../fieldset/FieldSet';
import Grid from '../../../../grid/Grid';
import AccountLinkForm from '../../../../form/AccountLinkForm';
import { EMPTY_GRID_DEFAULT_MESSAGE, } from '../../../../../modules/Constants';
import GRParkingDetailedCitationModal from './GRParkingDetailedCitationModal';
import GrIntegrationService from '../../../../../service/GrIntegrationService';
import ObjectUtils from '../../../../../modules/ObjectUtils';

class GRParking extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};

    this.comboFields = [
      {
        value: 'customerId',
        display: 'Customer ID',
      },
      {
        value: 'plateNumber',
        display: 'Plate Number',
      },
      {
        value: 'citationNumber',
        display: 'Citation Number',
      },
    ];
  }

  GRPARKING = 'gr_parking';

  onRowSelect(selectedRow) {
    const { citationRows, } = this.state;

    const citation = citationRows.find((row) => {
      const { raw, } = row;
      return raw.id === selectedRow.id;
    });

    this.setState({
      selectedCitation: citation.raw,
    });
  }

  getCitations(event) {
    this.reset();
    const { search, combo, } = event;
    const criteria = {};
    const rows = [];
    const headers = [];
    criteria[combo.value] = search.value;

    GrIntegrationService.getGrCitationsBySearchCriteria(criteria)
      .then((response) => {
        const { citations, } = response.data;

        let idIndex;
        let issueDateIndex;
        let balanceDueIndex;
        let initialFineIndex;
        let paidIndex;

        if (citations && citations.length > 0) {
          const filteredHeaders = Object.keys(citations[0]).filter((header, index) => {
            if (header === 'id') {
              idIndex = index;
            }
            if (header === 'issueDate') {
              issueDateIndex = index;
            }
            if (header === 'balanceDue') {
              balanceDueIndex = index;
            }
            if (header === 'initialFine') {
              initialFineIndex = index;
            }
            if (header === 'paid') {
              paidIndex = index;
            }

            return (
              header === 'id'
              || header === 'issueDate'
              || header === 'balanceDue'
              || header === 'initialFine'
              || header === 'paid'
            );
          });

          filteredHeaders.forEach((header) => {
            headers.push({
              value: header,
              display: _.startCase(header),
            });
          });

          citations.forEach((citation) => {
            const row = Object.values(citation);
            row[issueDateIndex] = moment(row[issueDateIndex])
              .utc()
              .format();
            row[paidIndex] = _.upperCase(row[paidIndex].toString());

            const filteredRow = row.filter(
              (_row, index) => index === idIndex
                || index === issueDateIndex
                || index === balanceDueIndex
                || index === initialFineIndex
                || index === paidIndex
            );
            rows.push({
              value: filteredRow,
              raw: citation,
            });
          });
        }

        this.setState({
          citationHeaders: headers,
          citationRows: rows,
        });
      })
      .catch((err) => {
        console.error(err);
      })
      .finally(() => {
        event.kill();
      });
  }

  reset() {
    this.setState({
      citationHeaders: [],
      citationRows: [],
      selectedCitation: null,
    });
  }

  showSelectedDetails(selectedCitation) {
    if (!selectedCitation) {
      return null;
    }
    return (
      <div>
        <p>{`Selected ID: ${selectedCitation.id}`}</p>
        <hr />
        <div className="row">
          <div className="m-1">
            <GRParkingDetailedCitationModal citation={selectedCitation} />
          </div>
          <div className="m-1">
            <AccountLinkForm
              id={selectedCitation.id}
              serviceOfferingId={this.GRPARKING}
              customerIds={ObjectUtils.formatStringAsJSONArray(selectedCitation.customerIds)}
            />
          </div>
        </div>
      </div>
    );
  }

  render() {
    const { citationHeaders = [], citationRows = [], selectedCitation, } = this.state;

    return (
      <div className="container">
        <SearchBar comboFields={this.comboFields} onClick={data => this.getCitations(data)} />
        <div style={{ marginTop: '50px', }}>
          <FieldSet title="Citations">
            <Grid
              headers={citationHeaders}
              rows={citationRows}
              onEmptyGridMessage={EMPTY_GRID_DEFAULT_MESSAGE}
              onRowSelect={row => this.onRowSelect(row)}
            />
          </FieldSet>
          {this.showSelectedDetails(selectedCitation)}
        </div>
      </div>
    );
  }
}

export default GRParking;
